"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailTemplateColumnType = exports["default"] = exports.TEMPLATE_GROUPS = exports.AVAILABLE_TEMPLATE_GROUPS = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Button2 = require("../../../Button/Button");
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _AttachmentList = _interopRequireDefault(require("../AttachmentList2"));
var _excluded = ["columns", "onClose", "onSubmit", "onSelectRow", "onSelectGroup", "className", "activeTemplateGroup", "isOpen"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TEMPLATE_GROUPS = exports.TEMPLATE_GROUPS = {
  COMMON: 'common',
  PERSONAL: 'personal'
};
var AVAILABLE_TEMPLATE_GROUPS = exports.AVAILABLE_TEMPLATE_GROUPS = [];
var emailTemplateColumnType = exports.emailTemplateColumnType = _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  value: _propTypes["default"].string
})), _propTypes["default"].objectOf({
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  value: _propTypes["default"].string
})]);
var TemplateColumn = function TemplateColumn(_ref) {
  var rows = _ref.rows,
    columnIndex = _ref.columnIndex,
    onSelectRow = _ref.onSelectRow,
    selectedRowIndex = _ref.selectedRowIndex;
  return /*#__PURE__*/_react["default"].createElement(StyledColumn, null, Array.isArray(rows) ? rows.map(function (_ref2, rowIndex) {
    var value = _ref2.value,
      id = _ref2.id;
    return /*#__PURE__*/_react["default"].createElement(StyledRow, {
      key: id,
      "data-id": id,
      "data-index-column": columnIndex,
      "data-index-row": rowIndex,
      onClick: onSelectRow,
      selected: selectedRowIndex === rowIndex
    }, value);
  }) : /*#__PURE__*/_react["default"].createElement(StyledPreviewRow, null, /*#__PURE__*/_react["default"].createElement(StyledPreview, {
    dangerouslySetInnerHTML: {
      __html: rows.value
    }
  }), rows.image_url && /*#__PURE__*/_react["default"].createElement(StyledPreviewAttachments, {
    list: [{
      url: rows.image_url,
      size: 0
    }]
  })));
};
var EmailTemplateForm = function EmailTemplateForm(_ref3) {
  var columns = _ref3.columns,
    onClose = _ref3.onClose,
    onSubmit = _ref3.onSubmit,
    onSelectRow = _ref3.onSelectRow,
    onSelectGroup = _ref3.onSelectGroup,
    className = _ref3.className,
    activeTemplateGroup = _ref3.activeTemplateGroup,
    isOpen = _ref3.isOpen,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedRowList = _useState2[0],
    setSelectedRowList = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    lastSelectedRowId = _useState4[0],
    setLastSelectedRowId = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isLastColumnSelected = _useState6[0],
    setIsLastColumnSelected = _useState6[1];
  var handleSelectRow = (0, _react.useCallback)(function (event) {
    var data = event.target.dataset;
    var id = data.id,
      indexColumn = data.indexColumn,
      indexRow = data.indexRow;
    var parsedIndexColumn = parseInt(indexColumn, 10);
    var parsedIndexRow = parseInt(indexRow, 10);
    setLastSelectedRowId(id);
    var newSelectedRowList = selectedRowList.slice(0, parsedIndexColumn + 1);
    newSelectedRowList[parsedIndexColumn] = parsedIndexRow;
    setSelectedRowList(newSelectedRowList);
    onSelectRow(id, parsedIndexColumn, parsedIndexRow);
  }, [onSelectRow, selectedRowList]);
  var handleSelectGroup = (0, _react.useCallback)(function (event) {
    var data = event.target.dataset;
    var group = data.group;
    onSelectGroup(group);
  }, [onSelectGroup]);
  var handleSubmit = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    onSubmit(columns[columns.length - 1]);
    onClose();
  }, [onSubmit, onClose, columns]);
  (0, _react.useEffect)(function () {
    setIsLastColumnSelected(lastSelectedRowId && !Array.isArray(columns[columns.length - 1]));
  }, [columns]);
  return /*#__PURE__*/_react["default"].createElement(StyledPopup, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(StyledForm, (0, _extends2["default"])({
    onSubmit: handleSubmit,
    className: className
  }, rest), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u0428\u0430\u0431\u043B\u043E\u043D\u044B"), /*#__PURE__*/_react["default"].createElement(StyledTypeTabs, null, AVAILABLE_TEMPLATE_GROUPS.map(function (_ref4) {
    var value = _ref4.value,
      title = _ref4.title;
    return /*#__PURE__*/_react["default"].createElement(StyledTypeTab, {
      key: value,
      onClick: handleSelectGroup,
      "data-group": value,
      selected: value === activeTemplateGroup
    }, title);
  })), /*#__PURE__*/_react["default"].createElement(StyledTable, null, columns && columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement(TemplateColumn, {
      key: index,
      selectedRowIndex: selectedRowList[index],
      onSelectRow: handleSelectRow,
      columnIndex: index,
      rows: column
    });
  })), /*#__PURE__*/_react["default"].createElement(StyledControl, null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    type: _Button2.Types.SUBMIT,
    disabled: !isLastColumnSelected
  }, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C"), /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: onClose
  }, "\u041E\u0442\u043C\u0435\u043D\u0430"))));
};
var StyledPopup = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "EmailTemplateForm__StyledPopup",
  componentId: "sc-1vkykiy-0"
})(["display:", ";align-items:center;justify-content:center;"], function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen ? 'flex' : 'none';
});
var StyledForm = _styledComponents["default"].form.withConfig({
  displayName: "EmailTemplateForm__StyledForm",
  componentId: "sc-1vkykiy-1"
})(["background:#ffffff;border-radius:6px;padding:10px;"]);
var StyledTypeTabs = _styledComponents["default"].ul.withConfig({
  displayName: "EmailTemplateForm__StyledTypeTabs",
  componentId: "sc-1vkykiy-2"
})(["display:flex;margin-top:15px;"]);
var StyledTypeTab = _styledComponents["default"].li.withConfig({
  displayName: "EmailTemplateForm__StyledTypeTab",
  componentId: "sc-1vkykiy-3"
})(["display:flex;cursor:pointer;padding:10px 15px;border:1px solid #007aff;box-sizing:border-box;border-radius:18px;background:", ";color:", ";margin-right:10px;&:last-of-type{margin-right:0;}"], function (_ref6) {
  var selected = _ref6.selected;
  return selected ? '#007AFF' : 'transparent';
}, function (_ref7) {
  var selected = _ref7.selected;
  return selected ? '#FFFFFF' : '#007AFF';
});
var StyledTitle = _styledComponents["default"].p.withConfig({
  displayName: "EmailTemplateForm__StyledTitle",
  componentId: "sc-1vkykiy-4"
})(["font-size:14px;line-height:18px;font-weight:bold;color:#17181a;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "EmailTemplateForm__StyledButton",
  componentId: "sc-1vkykiy-5"
})(["border-radius:4px;color:white;background-color:#007aff;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;", ""], function (props) {
  return props.disabled && "\n    background: #c2c5cc;\n    color: white;\n  ";
});
var StyledCancelButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "EmailTemplateForm__StyledCancelButton",
  componentId: "sc-1vkykiy-6"
})(["border:none;border-radius:4px;color:#4d4d4d;background-color:transparent;font-weight:normal;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;"]);
var StyledControl = _styledComponents["default"].div.withConfig({
  displayName: "EmailTemplateForm__StyledControl",
  componentId: "sc-1vkykiy-7"
})(["display:flex;"]);
var StyledTable = _styledComponents["default"].div.withConfig({
  displayName: "EmailTemplateForm__StyledTable",
  componentId: "sc-1vkykiy-8"
})(["display:flex;margin-top:10px;margin-bottom:80px;"]);
var StyledColumn = _styledComponents["default"].ul.withConfig({
  displayName: "EmailTemplateForm__StyledColumn",
  componentId: "sc-1vkykiy-9"
})(["display:flex;max-height:400px;min-width:300px;max-width:400px;overflow:auto;flex-direction:column;border-right:1px solid #e9ebee;&:last-of-type{border-right:none;}"]);
var StyledRow = _styledComponents["default"].li.withConfig({
  displayName: "EmailTemplateForm__StyledRow",
  componentId: "sc-1vkykiy-10"
})(["display:flex;font-size:14px;line-height:17px;cursor:pointer;color:#17181a;font-weight:", ";background:", ";padding:15px 10px;"], function (_ref8) {
  var selected = _ref8.selected;
  return selected ? 'bold' : 'normal';
}, function (_ref9) {
  var selected = _ref9.selected;
  return selected ? '#DCEDFF' : 'white';
});
var StyledPreviewRow = (0, _styledComponents["default"])(StyledRow).withConfig({
  displayName: "EmailTemplateForm__StyledPreviewRow",
  componentId: "sc-1vkykiy-11"
})(["flex-direction:column;"]);
var StyledPreview = _styledComponents["default"].div.withConfig({
  displayName: "EmailTemplateForm__StyledPreview",
  componentId: "sc-1vkykiy-12"
})(["display:flex;flex-direction:column;white-space:pre-line;overflow-y:auto;font-size:14px;line-height:17px;color:#17181a;"]);
var StyledPreviewAttachments = (0, _styledComponents["default"])(_AttachmentList["default"]).withConfig({
  displayName: "EmailTemplateForm__StyledPreviewAttachments",
  componentId: "sc-1vkykiy-13"
})(["margin-top:15px;"]);
EmailTemplateForm.propTypes = {
  onClose: _propTypes["default"].func,
  onSelectRow: _propTypes["default"].func,
  columns: _propTypes["default"].arrayOf(emailTemplateColumnType),
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  activeTemplateGroup: _propTypes["default"].string,
  onSelectGroup: _propTypes["default"].func,
  isOpen: _propTypes["default"].bool
};
EmailTemplateForm.defaultProps = {
  onClose: Function.prototype,
  onSelectRow: Function.prototype,
  onSubmit: Function.prototype,
  onSelectGroup: Function.prototype,
  columns: [],
  className: '',
  activeTemplateGroup: '',
  isOpen: false
};
TemplateColumn.propTypes = {
  rows: emailTemplateColumnType,
  columnIndex: _propTypes["default"].number,
  onSelectRow: _propTypes["default"].func,
  selectedRowIndex: _propTypes["default"].number
};
TemplateColumn.defaultProps = {
  rows: [],
  columnIndex: 0,
  selectedRowIndex: null,
  onSelectRow: Function.prototype
};
var _default = exports["default"] = EmailTemplateForm;